import React, { Fragment } from 'react';
import { Header, Button, Image } from 'components';
import * as Icons from './icons';
import css from './hero.scss';

export function Hero(props) {
  return (
    <div className={css.hero}>

      <div className={[css.background, props.status].join(' ')} />

      <Header.Compensate ref={props.refHeaderBreakpoint} />

      <div className={css.relative}>
        <h1>Features & Benefits</h1>
        <div className={css.container}>
          <ul className={css.grid}>
            <li>
              <Icons.Structured />
              <h5>Complete & Structured</h5>
              <p>Complete and structured personal development and online coaching program.</p>
            </li>
            <li>
              <Icons.Routines />
              <h5>Structured Daily Routines</h5>
              <p>Ensure effective focused action and continuous self-improvement.</p>
            </li>
            <li>
              <Icons.Progress />
              <h5>Progress Analyzer</h5>
              <p>Keeps track and monitors your progress towards your life vision.</p>
            </li>
            <li>
              <Icons.Hill />
              <h5>Proprietary Four-Module Program</h5>
              <p>Walks you step-by-step through a powerful process of gaining clarity and self-awareness, setting meaningful goals, and developing a purpose-driven roadmap and action plan, that will lead you to where you want to go.</p>
            </li>
            <li>
              <Icons.Diary />
              <h5>Personal Journal & Notepad</h5>
              <p>A private place for you to jot down your thoughts, realizations, and experiences. Use it frequently to connect with yourself and your life journey.</p>
            </li>
            <li>
              <Icons.Notepad />
              <h5>E-Notepad</h5>
              <p>A place to record your ideas, take notes, and keep track of your questions, concerns and daily aha moments. Simply type in whatever comes to mind throughout the day so you can go back and review your notes later.</p>
            </li>
            <li>
              <Icons.Social />
              <h5>Team Collaboration</h5>
              <p>Share your progress and success, and get support from your accountability team or mastermind group</p>
            </li>
            <li>
              <Icons.Management />
              <h5>Effective Time Management Tools</h5>
              <p>Keep you focused on the things that are most important to you.</p>
            </li>
            <li>
              <Icons.Coaching />
              <h5>Personal Coaching</h5>
              <p>Available (for additional fee) to enhance and deepen your personal journey through one-on-one coaching, provided by our team of certified coaches and specialists</p>
            </li>
            <li>
              <Icons.Hello />
              <h5>Interactive & Engaging User Interface</h5>
              <p>Allows for personalized, unique and powerful user experience</p>
            </li>
            <li>
              <Icons.Eye />
              <h5>Private & Secure</h5>
              <p>Anonymous signup and encrypted connection let you maintain your journey completely private and secure.</p>
            </li>
            <li>
              <Icons.Award />
              <h5>Guaranteed</h5>
              <p>Try it risk-free for 60 days and if you don't feel a shift and don't believe your life has been changed, you will receive a full refund.</p>
            </li>

          </ul>
        </div>
      </div>


    </div>
  );
}

